<template>
  <div>
    <div class="media-list">
      <el-row type="flex" align="bottom">
        <el-col :span="22">
          <div class="breadcrumb-bar">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item>授权课程</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="tableList">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="体系课" name="first">
          <el-form
            :inline="true"
            :model="formPackage"
            label-width="90px"
            class="searchForm"
          >
            <el-form-item label="应用：">
              <el-select
                v-model="formPackage.useName"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in getUseData"
                  :key="item.appId"
                  :label="item.name"
                  :value="item.appId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item label="课程名称:">
              <el-input
                v-model="formPackage.name"
                placeholder="输入课程名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="search" @click="onQuery"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
          <br />
          <el-table
            ref="multipleTable"
            :data="queryData"
            tooltip-effect="dark"
            :header-cell-style="rowClass"
            id="Table"
            @selection-change="handleSelectionChange"
            v-loading.body="loading"
          >
            <el-table-column
              prop="id"
              label="课程ID"
              align="center"
              width="100"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="toauthorization(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.id }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="课程名称"
              align="center"
              width="300"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="toauthorization(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop=""
              label="课程类型"
              align="center"
              min-width="80"
              >体系课</el-table-column
            >
            <el-table-column
              prop="level"
              label="级别"
              align="center"
              min-width="80"
            ></el-table-column>
            <el-table-column
              prop="period"
              label="课程周期"
              align="center"
              min-width="80"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.period == 1">日</span>
                <span v-if="scope.row.period == 2">周</span>
                <span v-if="scope.row.period == 3">月</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="authCount"
              label="授权机构"
              align="center"
              min-width="80"
            ></el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="125"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="toauthorization(scope.row)"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClickSe(scope.row)"
                  >授权</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="queryParams.page"
              :page-sizes="[20, 50, 100]"
              :page-size="queryParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 特色课程列表 -->
        <el-tab-pane label="特色课程" name="second">
          <el-form
            :inline="true"
            :model="formPackage"
            label-width="140px"
            class="searchForm"
          >
            <el-form-item label="应用：">
              <el-select
                v-model="formPackage1.useName"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in getUseData1"
                  :key="item.appId"
                  :label="item.name"
                  :value="item.appId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item label="特色课程名称:" style="width:">
              <el-input
                v-model="formPackage1.name"
                placeholder="输入特色课程名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="search" @click="onQuery1"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
          <br />
          <el-table
            ref="multipleTable"
            :data="extraData"
            :header-cell-style="rowClass"
            id="Table"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading.body="loading"
          >
            <el-table-column
              prop="id"
              label="特色课程ID"
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="toOil(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.id }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="name"
              label="特色课程名称"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                <a
                  href="javascript:;"
                  @click="toOil(scope.row, 'Course')"
                  style="color: #1d90e6"
                  >{{ scope.row.name }}</a
                >
              </template>
            </el-table-column>
            <el-table-column prop="" label="课程类型" align="center" width="90">
              特色课程</el-table-column
            >
            <el-table-column
              prop="level"
              label="级别"
              align="center"
              width="90"
            ></el-table-column>

            <el-table-column
              prop="authCount"
              label="授权机构"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="125"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button @click="toOil(scope.row)" type="text" size="small"
                  >查看</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleClickSeAgin(scope.row)"
                  >授权</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page.sync="queryParams1.page"
              :page-sizes="[20, 50, 100]"
              :page-size="queryParams1.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageTotal1"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 体系课授权列表 -->
      <el-dialog
        :visible.sync="modalShow"
        width="48%"
        center
        title="体系课授权机构"
        :before-close="handleClose"
      >
        <el-form :inline="true" :model="formPkg" label-width="90px">
          <el-form-item label="机构名称:">
            <el-input
              v-model="formPkg.name"
              placeholder="请输入机构名称"
              style="width: 160px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuery2">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="multipleTable"
          :data="authorizationData"
          :header-cell-style="rowClass"
          stripe
          border
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
          style="width: 100%"
          class="elTable"
          id="Table"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="id" label="机构ID" align="center">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                @click="viewPackage(scope.row)"
                style="color: #1d90e6"
                >{{ scope.row.appId }}</a
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="机构名称" align="center">
          </el-table-column>
          <el-table-column prop="authInfo" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.authInfo.length != 0">
                {{ scope.row.authInfo[1] | formatDate2 }}到期
              </span>
              <span v-else> 未授权 </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            style="overflow: hidden"
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page.sync="queryParams2.page"
            :page-sizes="[10, 20, 40, 50]"
            :page-size="5"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal2"
          ></el-pagination>
        </div>
        <h4>授权期限</h4>
        <br />
        <el-form>
          <el-form-item>
            <div style="display: inline-block">
              开始时间：
              <el-date-picker
                v-model="formPkg.beginTime"
                type="date"
                placeholder="必填项"
                value-format="yyyy-MM-dd"
                placement="bottom-end"
                @on-change="beginTimeChgHandle"
              ></el-date-picker>
            </div>
            <div style="display: inline-block">
              结束时间：
              <el-date-picker
                v-model="formPkg.finishTime"
                type="date"
                placeholder="必填项"
                value-format="yyyy-MM-dd"
                placement="bottom-end"
                @on-change="finishTimeChgHandle"
              ></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div class="line"></div>
        <div class="btn">
          <el-button type="primary" @click="toAuthor">确定</el-button>
          <el-button type="primary" @click="cancel">取消</el-button>
        </div>
      </el-dialog>
      <!-- 特色课程授权列表 -->
      <el-dialog
        :visible.sync="modalShowAgin"
        width="45%"
        center
        title="特色课程授权机构"
        :before-close="handleClose"
      >
        <el-form :inline="true" :model="formPkgAgin" label-width="90px">
          <el-form-item label="机构名称:">
            <el-input
              v-model="formPkgAgin.name"
              placeholder="请输入机构名称"
              style="width: 160px"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuery3">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="multipleTable2"
          :header-cell-style="rowClass"
          :data="authorizationDataAgin"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          class="elTable"
          @selection-change="handleSelectionChange2"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="id" label="机构ID" align="center">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                @click="viewPackage(scope.row)"
                style="color: #1d90e6"
                >{{ scope.row.appId }}</a
              >
            </template>
          </el-table-column>
          <el-table-column prop="name" label="机构名称" align="center">
          </el-table-column>
          <el-table-column prop="authInfo" label="状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.authInfo.length != 0">
                {{ scope.row.authInfo[1] | formatDate2 }}到期
              </span>
              <span v-else>未授权</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            style="overflow: hidden"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange3"
            :current-page.sync="queryParams3.page"
            :page-sizes="[10, 20, 40, 50]"
            :page-size="queryParams3.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
        <h4>授权期限</h4>
        <el-form>
          <el-form-item>
            <div style="display: inline-block">
              开始时间：
              <el-date-picker
                v-model="formPkgAgin.beginTime"
                type="date"
                placeholder="必填项"
                value-format="yyyy-MM-dd"
                placement="bottom-end"
                @on-change="beginTimeChgHandle"
              ></el-date-picker>
            </div>
            <div style="display: inline-block">
              结束时间：
              <el-date-picker
                v-model="formPkgAgin.finishTime"
                type="date"
                placeholder="必填项"
                value-format="yyyy-MM-dd"
                placement="bottom-end"
                @on-change="finishTimeChgHandle"
              ></el-date-picker>
            </div>
          </el-form-item>
        </el-form>
        <div class="line"></div>
        <div class="btn">
          <el-button @click="toAuthorAgin" type="primary">确定</el-button>
          <el-button @click="cancel1" type="primary">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import moment from "moment";
import { ApiMessage, formatDate } from "@/utils/util";

export default {
  name: "grant",
  data() {
    return {
      getUseData: [],
      getUseData1: [],
      authInfo: "",
      getMonth: "",
      statu: "",
      statu1: "",
      activeName: "first",
      loading: true,
      queryData: [],
      extraData: [],
      authorizationData: [],
      authorizationDataAgin: [],
      multipleSelection: [],
      multipleSelectionAgin: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      queryParams1: {
        page: 1,
        pageSize: 20,
      },
      queryParams2: {
        page: 1,
        pageSize: 10,
      },
      queryParams3: {
        page: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      pageTotal1: 0,
      pageTotal2: 0,
      formPackage: {
        name: "",
        useName: "",
      },
      formPackage1: {
        name: "",
        useName: "",
      },
      formPkgAgin: {
        name: "",
        beginTime: "",
        finishTime: "",
      },
      modalShow: false,
      modalShowAgin: false,
      formPkg: {
        id: "",
        name: "",
        beginTime: "",
        finishTime: "",
      },
      newId: "",
      needId: "",
      needOilId: "",
      needDateNum: [],
      nowData: "",
    };
  },
  components: {},

  props: {},
  created() {
    this.fetchPackageList();
    this.fetchUseData();
    this.fetchUseData1();
    this.dateNow();
  },
  computed: {},
  mounted() {},
  watch: {},
  filters: {
    formatDate2(d) {
      return formatDate(d, "yyyy-MM-dd");
    },
  },
  methods: {
    checkStartAndBeginTime(finishTime, nowData) {
      // let time = new Date(nowData);
      // console.log(time,'从别处哪来的-------------');
      // console.log(this.nowData,'自身的-----------');
      // let begin = parseInt(time.getTime() / 1000);
      // // console.log(begin);
      // time = new Date(startTime);
      // let start = parseInt(time.getTime() / 1000);
      // // console.log(start);
      if (finishTime > nowData) {
        console.log(finishTime, "nowData=======");
        console.log(nowData, "finishTime==================");
        alert("授权时间不能晚于今天");
        return;
      } else {
        console.log("0000000000000000");
      }
    },
    dateNow() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      date = date < 10 ? "0" + date : date;
      if (month < 10) {
        this.nowData = year + "-" + "0" + month + "-" + date;
      } else {
        this.nowData = year + "-" + month + "-" + date;
      }

      console.log(this.nowData, "当前时间");
    },
    handleClose(done) {
      done();
    },
    cancel1() {
      this.modalShowAgin = false;
    },
    cancel() {
      this.modalShow = false;
    },
    fetchUseData1() {
      let params = {
        appId: this.$API.APPID,
        pageSize: 500,
      };
      this.$axios
        .post("edu/eduAdmin/course/fyd_app_list", params)
        .then((response) => {
          this.getUseData1 = response.data.data.list;
        });
    },
    fetchUseData() {
      let params = {
        appId: this.$API.APPID,
        pageSize: 500,
      };
      this.$axios
        .post("edu/eduAdmin/course/fyd_app_list", params)
        .then((response) => {
          this.getUseData = response.data.data.list;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelectionAgin = val;
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    toAuthor() {
      // for (let i = 0; i < this.multipleSelection.length; ++i) {
      //   let idDel = this.multipleSelection[i].appId;
      //   console.log(idDel);
      //   ids.push(idDel);
      // }
      let ids = this.multipleSelection.map((ids) => {
        return ids.appId;
      });

      if (ids.length <= 0) {
        alert("请先选择机构");
        return;
      }
      if (!this.formPkg.beginTime || !this.formPkg.finishTime) {
        alert("开始时间和结束时间不能为空");
        return;
      } else if (this.formPkg.beginTime > this.formPkg.finishTime) {
        alert("授权结束时间不能早于开始时间");
        return;
      }
      if (
        moment(this.formPkg.finishTime).unix() + 86400 - 1 <
        moment(new Date()).unix()
      ) {
        alert("授权结束时间不能早于今天");
        return;
      }

      console.log(ids);
      // if(this.formPkg.finishTime>this.nowData){
      //   alert('结束时间可以')
      //   return
      // }
      let getStartTime = moment(this.formPkg.beginTime).unix();
      let getEndTime = moment(this.formPkg.finishTime).unix() + 86400 - 1;

      let params = {
        appId: this.$API.APPID,
        resourceId: Number(this.needId),
        resourceType: 1,
        targetAppIds: ids,
        startTime: getStartTime,
        endTime: getEndTime,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };
      console.log(params.startTime, "params===========");

      this.axios
        .post("edu/eduAdmin/course/fyd_set_auth_info", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$Message.success("授权成功!");
            this.fetchPackageList();
            this.formPkg == "";
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
      this.modalShow = false;
    },
    toAuthorAgin() {
      let getStartTime1 = moment(this.formPkgAgin.beginTime).unix();
      let getEndTime1 = moment(this.formPkgAgin.finishTime).unix() + 86400 - 1;

      let ids1 = [];
      for (let i = 0; i < this.multipleSelectionAgin.length; ++i) {
        let idDel1 = this.multipleSelectionAgin[i].appId;
        ids1.push(idDel1);
      }
      let params = {
        appId: this.$API.APPID,
        resourceId: Number(this.needOilId),
        resourceType: 2,
        targetAppIds: ids1,
        startTime: getStartTime1,
        endTime: getEndTime1,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };

      if (ids1 == "") {
        alert("请先选择机构");
        return;
      }

      if (!this.formPkgAgin.beginTime || !this.formPkgAgin.finishTime) {
        alert("开始时间和结束时间不能为空");
        return;
      } else if (this.formPkgAgin.beginTime > this.formPkgAgin.finishTime) {
        // console.log(this.formPkgAgin.beginTime,'this.formPkgAgin.beginTime====');
        // console.log(this.formPkgAgin.finishTime,'this.formPkgAgin.finishTime======');
        alert("授权结束时间不能早于开始时间");
        return;
      }
      if (
        moment(this.formPkgAgin.finishTime).unix() + 86400 - 1 <
        moment(new Date()).unix()
      ) {
        alert("授权结束时间不能早于今天");
        return;
      }
      this.axios
        .post("edu/eduAdmin/course/fyd_set_auth_info", params)
        .then((response) => {
          if (response.data.rc == "0") {
            this.$Message.success("授权成功!");
            this.fetchExtraList();
          } else {
            alert(response.data.err);
          }
        })
        .catch((error) => {
          ApiMessage(this, error.toString(), "error");
        });
      this.modalShowAgin = false;
    },
    toauthorization(pkg) {
      this.$router.push({
        name: "detailAuthorization",
        query: {
          id: pkg.id,
        },
      });
    },
    toOil(pkg) {
      this.$router.push({
        name: "detailOil",
        query: {
          id: pkg.id,
        },
      });
    },
    onQuery2() {
      let id = this.needId;
      this.queryParams2.page = 1;
      this.authorizationList(id);
    },
    onQuery3() {
      let id = this.needOilId;
      this.queryParams3.page = 1;
      this.authorizationListAgin(id);
    },
    handleClickSe(val) {
      if (val.enabled == true) {
        this.modalShow = true;
        let id = val.id;
        this.needId = id;
        this.authorizationList(id);
      } else {
        // return
        alert("请先将课程上架，再进行授权");
        return;
      }
    },
    // 体系课授权列表
    authorizationList(id) {
      let params = {
        appId: this.$API.APPID,
        resourceId: Number(id),
        resourceType: 1,
        pageSize: this.queryParams2.pageSize,
        page: this.queryParams2.page,
      };
      if (this.formPkg.name != "") {
        params.targetAppName = this.formPkg.name;
      }
      this.$axios
        .post("edu/eduAdmin/course/fyd_get_auth_list", params)
        .then((response) => {
          // if (response != null) {
          if (response.data.data != undefined) {
            this.authorizationData = response.data.data.list;
            this.pageTotal2 = response.data.data.pager.total;
          } else {
            return;
          }

          // }
        });
    },
    handleClickSeAgin(val) {
      if (val.enabled == true) {
        this.modalShowAgin = true;
        let idAgin = val.id;
        this.needOilId = idAgin;
        this.authorizationListAgin(idAgin);
      } else {
        alert("请先将课程上架，再进行授权");
      }
    },
    // 特色课程授权列表
    authorizationListAgin(idAgin) {
      let params = {
        appId: this.$API.APPID,
        resourceId: Number(idAgin),
        resourceType: 2,
        pageSize: this.queryParams3.pageSize,
        page: this.queryParams3.page,
      };
      if (this.formPkgAgin.name != "") {
        params.targetAppName = this.formPkgAgin.name;
      }
      this.$axios
        .post("edu/eduAdmin/course/fyd_get_auth_list", params)
        .then((response) => {
          if (response != null) {
            this.authorizationDataAgin = response.data.data.list;
            this.pageTotal = response.data.data.pager.total;
          }
        });
    },
    onQuery() {
      this.queryParams.page = 1;
      this.fetchPackageList();
    },
    onQuery1() {
      this.queryParams1.page = 1;
      this.fetchExtraList();
    },
    // 体系课列表
    fetchPackageList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
        packageType: 1, // 1:自有课程   2.购买课程
        isIncludeAuthInfo: true,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
      };
      // if (this.formPackage.id != "") {
      //   params.id = this.formPackage.id;
      // }
      if (this.formPackage.name != "") {
        params.name = this.formPackage.name;
      }
      if (this.formPackage.useName != "") {
        params.targetAppIds = this.formPackage.useName;
      }
      // if (this.formPackage.level != "") {
      //   params.level = this.formPackage.level;
      // }
      this.$axios
        .post("/edu/eduAdmin/course/package_list", params)
        .then((res) => {
          if (res != null) {
            let m = res;
            this.queryData = m.data.data.list;
            this.pageTotal = m.data.data.pager.total;
          }
          this.loading = false;
        });
    },
    // 特色课程列表
    fetchExtraList() {
      let params = {
        appId: this.$API.APPID,
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        courseType: 1,
        isIncludeAuthInfo: true,
      };
      if (this.formPackage1.name != "") {
        params.name = this.formPackage1.name;
      }
      if (this.formPackage1.useName != "") {
        params.targetAppIds = this.formPackage1.useName;
      }
      params.pageSize = this.queryParams1.pageSize;
      params.page = this.queryParams1.page;
      this.$axios
        .post("/edu/eduAdmin/course/extra_list", params)
        .then((response) => {
          if (response != null) {
            let m = response;
            this.extraData = m.data.data.list;
            this.pageTotal1 = m.data.data.pager.total;
          }
        });
    },
    rowClass() {
      return "background:#f9f9f9;color:#000000;font-size:14px;height:22px";
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.index == "0") {
        //tixike
        this.queryParams.page = 1;
        this.fetchPackageList();
      } else if (tab.index == "1") {
        //jiayoubao
        this.queryParams1.page = 1;
        this.fetchExtraList();
      }
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchPackageList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchPackageList();
    },
    handleSizeChange1(val) {
      this.queryParams1.pageSize = val;
      this.fetchExtraList();
    },
    handleCurrentChange1(val) {
      this.queryParams1.page = val;
      this.fetchExtraList();
    },
    handleSizeChange2(val) {
      this.queryParams2.pageSize = val;
      this.authorizationList(this.needId);
    },
    handleCurrentChange2(val) {
      this.queryParams2.page = val;
      this.authorizationList(this.needId);
    },
    handleSizeChange3(val) {
      this.queryParams3.pageSize = val;
      this.authorizationListAgin(this.needOilId);
    },
    handleCurrentChange3(val) {
      this.queryParams3.page = val;
      this.authorizationListAgin(this.needOilId);
    },
    beginTimeChgHandle() {},
    finishTimeChgHandle() {},
  },
};
</script>
<style lang="less" scoped>
@import "../fyd-style";
@import "../commonEdu";
.line {
  height: 1px;
  width: 100%;
  background: rgb(233, 232, 232);
}

.line1 {
  margin-top: -20px;
  height: 1px;
  width: 100%;
  background: rgb(228, 227, 227);
  margin-bottom: 10px;
}

.btn {
  margin-top: 30px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// grant.vue?01601183